import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";

const AlunosSelector = (props) => {
  const [aluno, setAluno] = useState("");
  const [alunosOptions, setAlunosOptions] = useState([]);
  const [alunoSearch, setAlunoSearch] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idsCadastrados, setIdsCadastrados] = useState([]);

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      const text = options.find((option) => option.value === value).text;

      setAluno(value);
      setAlunoSearch(text);

      if (props.cadastrou) {
        props.cadastrou(idsCadastrados.includes(value));
      }
    },
    [props, idsCadastrados]
  );

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;

    setAlunoSearch(search);

    const cleanSearch = search.trim();

    api.get(`alunos?search=${cleanSearch}&limit=15`).then((res) => {
      if (res.data.length > 0) {
        const options = res.data.map((pessoa, index) => ({
          key: index,
          text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
          value: pessoa.id,
        }));
        setAlunosOptions(options);
        return;
      }
      setAlunosOptions([]);
    });
  });

  const cadastrarAluno = useCallback(
    (e) => {
      // const senha_pessoa = Math.random().toString(36).split(".").pop();
      const senha_pessoa = "voitto#pass";

      api
        .post("/admin/signup-authenticate", {
          nome,
          email,
          senha_pessoa,
        })
        .then((res) => {
          const { pessoa } = res.data;
          const newAlunosOptions = [...alunosOptions];
          const key = newAlunosOptions.length;
          const text = `(${pessoa.email}) [ID: ${pessoa.id}]`;
          const value = pessoa.id;

          newAlunosOptions.push({ key, text, value });

          setAlunosOptions(newAlunosOptions);
          setAlunoSearch(text);
          setAluno(value);

          setIsModalOpen(false);
          setEmail("");
          setNome("");

          if (props.cadastrou) {
            props.cadastrou(true);
          }

          setIdsCadastrados((idsCadastrados) => [...idsCadastrados, pessoa.id]);

          swal("Email cadastrado com sucesso", "", "success");
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            swal("Erro ao cadastrar email", err.response.data.message, "error");
            return;
          }
          swal("Erro ao cadastrar email", "", "error");
        });
    },
    [nome, email, alunosOptions, props]
  );

  const initialLoad = useCallback(async () => {
    try {
      if (aluno) {
        return;
      }

      const id = props.initialValue;

      if(!id) {
        return;
      }

      const { aluno: alunoResponse } = (await api.get(`alunos/${id}`)).data;

      const newAlunosOptions = [
        {
          key: 0,
          text: `(${alunoResponse.email}) [ID: ${alunoResponse.id}]`,
          value: alunoResponse.id,
        },
      ];

      setAlunosOptions(newAlunosOptions);
      setAluno(id);
    } catch (err) {
      console.error(err);
      return;
    }
  }, [props, aluno]);

  useEffect(() => {
    initialLoad();
  }, [props]);

  const handleChange = useCallback(() => {
    props.handleChange(aluno);
  }, [props, aluno]);

  useEffect(() => {
    handleChange();
  }, [aluno]);

  return (
    <Container>
      <div>
        {!props.isDash ? <Label>Selecione o aluno</Label> :<></>}
        <Dropdown
          placeholder={"Consulta rápida aluno (Busque pelo ID, Nome ou E-mail)"}
          fluid
          search
          selection
          options={alunosOptions}
          onChange={handleAlunoChange}
          searchQuery={alunoSearch}
          onSearchChange={handleAlunoSearchChange}
          value={aluno}
        />
      </div>

      {props.cadastro && (
        <>
          <Button
            type="button"
            color={"black"}
            onClick={() => setIsModalOpen(true)}
          >
            <Icon name="plus" /> Cadastrar aluno
          </Button>

          <Modal
            size={"small"}
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            <Modal.Header>Cadastrar Aluno</Modal.Header>

            <Modal.Content>
              <Field>
                <Label>Nome</Label>
                <Input value={nome} onChange={(e) => setNome(e.target.value)} />
              </Field>

              <Field>
                <Label>Email</Label>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
            </Modal.Content>

            <Modal.Actions>
              <Button type="button" positive onClick={cadastrarAluno}>
                Cadastrar
              </Button>
              <Button
                type="button"
                negative
                onClick={() => {
                  setIsModalOpen(false);
                  setEmail("");
                  setNome("");
                }}
              >
                Cancelar
              </Button>
            </Modal.Actions>
          </Modal>
        </>
      )}
    </Container>
  );
};

export default AlunosSelector;
